import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { initSync } from './sync/manager';
import { registerSw } from './sync/push';
import './index.css';

// 启动同步 (WS 连接 + 离线队列)
initSync();

// 注册 service worker (用于离线缓存 + Web Push)
// 不阻塞 UI 启动
void registerSw();

const root = document.getElementById('root');
if (!root) throw new Error('No #root element');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);